// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__F_s4-","loaderOuter":"PageOverlayLoader_loaderOuter__18n13"};